import {
	rGet,
	rPost
} from '@/utils/http.js';
// import axios from 'axios';
import store from '@/store';

/**
 * 搜索店铺
 */
export function queryStore(keywords) {


	const city = store.getters.getCity?.city || '全部'; // ‌:ml-citation{ref="1,2" data="citationList"}


	return rPost('Keywords_Store', {
		city,
		keywords
	});
}

/**
 * 获取城市
 * @returns 
 */
export function getCity() {
	return rGet('/Get_All_Cities');
}

/**
 *  获取商铺
 */
export function getShop() {

	const cityData = store.getters.getCity;
	if (!cityData || !cityData.center) return Promise.resolve([]);

	const xy = cityData.center.split(',');

	return rPost('/Get_Store_List', {
		latitude: xy[1],
		longitude: xy[0]
	});
}

/**
 *  获取店铺商品
 */
export function getGoods() {
	var id = store.getters.getStore.id

	return rPost('/Get_All_Detail', {
		store_id: id
	});
}

/**
 * 获取指定商品信息
 * @param {*} pid 商品id
 * @returns 
 */
export function getGoodsInfo(pid) {
	var id = store.getters.getStore.id

	return rPost('/Get_Detail_info', {
		store_id: id,
		product_id: pid
	}, {
		isLoad: true
	});
}

/**
 * 获取指定商品信息(v2)
 * @param {*} pid 商品id
 * @returns
 */
export function getGoodsInfo2(pid) {
	var id = store.getters.getStore.id

	return rPost('/Get_Detail_info2', {
		store_id: id,
		product_id: pid
	}, {
		isLoad: true
	});
}


export function addCart(products) {
	var id = store.getters.getStore.id

	return rPost('/Add', {
		store_id: id,
		products: JSON.stringify([products])
	}, {
		isLoad: true
	});
}

/**
 * 获取购物车
 * @param {*} products 
 * @returns 
 */
export function getShoppingCart() {
	var id = store.getters.getStore.id;
	var city = store.getters.getCity['city'];

	return rPost('/Get_Shopping_Cart', {
		store_id: id,
		city: city
	}, {
		isLoad: true
	});
}

/**
 * 获取店铺优惠券信息
 * @returns 
 */
export function getReview(expect_date, cache) {
	var id = store.getters.getStore.id;

	var city = store.getters.getCity['city'];

	return rPost('/Get_Review', {
		store_id: id,
		expect_date: expect_date,
		cache: JSON.stringify(cache),
		city: city
	}, {
		isLoad: true
	});
}


export function update(data) {
	var id = store.getters.getStore.id
	return rPost('/Update', {
		store_id: id,
		data: JSON.stringify(data)
	}, {
		isLoad: true
	});
}

/**
 * 减去商品
 * @param {*} cId 
 * @returns 
 */
export function reduce(cId) {
	var id = store.getters.getStore.id

	return rPost('/Reduce', {
		store_id: id,
		cart_product_id: cId
	}, {
		isLoad: true
	});
}


/**
 * 清空购物车
 * @param {*} cId 
 * @returns 
 */
export function ClearShoppingCart() {
	var id = store.getters.getStore.id

	return rPost('/Clear_Shopping_Cart', {
		store_id: id

	});
}





/**
 * 确认下单
 * @param {*} cId 
 * @returns 
 */
export function sendSubmit(cache, coupons, star_options, data, name, expect_date, payment_method, needPackage, SrkitInfo,
	gifts) {


	var id = store.getters.getStore.id;
	var _store = store.getters.getStore;
	var city = store.getters.getCity['city'];
	return rPost('/Send_Submit', {
		name: name,
		store_id: id,
		cache: JSON.stringify(cache),
		coupons: JSON.stringify(coupons),
		...data,
		star_options: JSON.stringify(star_options),
		gifts: JSON.stringify(gifts),
		// order_lines:JSON.stringify(order_lines),
		address: _store.address,
		latitude: _store.latitude,
		longitude: _store.longitude,
		expect_date: expect_date,
		payment_method: payment_method,
		needPackage: needPackage,
		SrkitInfo: JSON.stringify(SrkitInfo),
		city: city

	}, {
		isLoad: true
	});
}

/**
 * 获取历史订单
 * @returns 
 */
export function getOrder() {
	return rPost('/Get_Orders');
}

/**
 * 获取历史订单
 * @returns 
 */
export function pendingOrders() {
	return rPost('/pendingOrders');
}



/**
 * 获取店铺优惠价
 * @returns 
 */
export function getRewards(header) {
	var id = store.getters.getStore.id


	return rPost('/Get_Rewards', {
		store_id: id,
		header: JSON.stringify(header)
	}, {
		isLoad: true
	});
}

/**
 * 提交优惠券与订单信息
 * @param {*} coupons 
 * @param {*} order_lines 
 * @returns 
 */
export function sendApply(cache, coupons, star_options, orderLines, SrkitInfo, gifts) {
	var id = store.getters.getStore.id;
	var city = store.getters.getCity['city'];

	var data = {
		store_id: id,
		cache: JSON.stringify(cache),
		coupons: JSON.stringify(coupons),
		star_options: JSON.stringify(star_options),
		orderLines: JSON.stringify(orderLines),
		usedGifts: JSON.stringify(gifts),
		SrkitInfo: JSON.stringify(SrkitInfo),
		city: city



	};


	return rPost('/Send_Apply', data, {
		isLoad: true
	});
}

/**
 * 订单详情
 * @param {*} orderId 
 * @returns 
 */
export function orderDetails(orderId) {
	var data = {
		orderId: orderId
	};

	return rPost('/Order_details', data, {
		isLoad: true
	});
}

// 再次支付 
export function againPay(orderId, storeId) {
	var data = {
		orderId: orderId,
		store_id: storeId
	};

	return rPost('/Again_Pay', data, {
		isLoad: true
	});
}

export function cancelPay(orderId) {
	var data = {
		orderId: orderId
	};
	return rPost('/Cancel_Pay', data, {
		isLoad: true
	});
}

// 获取口令
export function getPassword(orderId) {
	return rPost('/Get_Password', {
		orderId
	});
}

// 绑定卡
export function sendCard(id, pin) {
	return rPost('/Send_Card', {
		id,
		pin
	});
}

//定时领取
export function timeLists(store_id) {
	return rPost('/Time_lists', {
		store_id
	});
}


// 二维码
export function getQr() {
	// return axios.post(
	//     process.env.VUE_APP_BASE_API+"/Get_qr",
	//     {
	//         sign: store.getters.getSign
	//     },{
	//         headers:{
	//             'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
	//         } 
	//     }
	// ).then(response=>{
	//     console.log(response);
	//     return 'data:image/png;base64,' + btoa(
	//         new Uint8Array(response.data)
	//           .reduce((data, byte) => data + String.fromCharCode(byte), '')
	//       );
	// });
	return rPost("/Get_qr")

	// return 'data:image/png;base64,' + btoa(
	//     new Uint8Array(response.data)
	//       .reduce((data, byte) => data + String.fromCharCode(byte), '')
	//   );
}

// 
export function share_code(orderId) {
	var data = {
		orderId: orderId

	};

	return rPost('/Share_code', data, {
		isLoad: true
	});
}

export function share(orderId, name) {
	var data = {
		orderId: orderId,
		name: name

	};

	return rPost('/Share', data, {
		isLoad: true
	});

}

export function getSrkit() {
	var id = store.getters.getStore.id
	var data = {
		store_id: id

	};

	return rPost('/Get_Srkit', data, {
		isLoad: true
	});

}